import "./NotFound.css";
function NotFound() {
  return <div id="notFound">Not Found</div>;
}
export default NotFound;